import { USER_ROLES, USER_STATUS } from "../enums/enums";

export class User {
  constructor(
    public id:        string,
    public name:      string,
    public lastname:  string,
    public email:     string,
    public password:  string,
    public role:      USER_ROLES,
    public status:    USER_STATUS,
  ) { }
}